module.exports = new __parcel__URL__("logo_size.fc7c0ced.jpg").toString();